import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ISoundtrack } from '../../../@types/ISoundtrack';
import { IUser } from '../../../@types/IUser';
import hv_player_api from '../../../api/hv_player_api';
import MediaFlatItem from '../../shared/MediaFlatitem';
import MediaFlatlist from '../../shared/MediaFlatlist';
import { getMiddleColumn } from '../../shared/viewsHelper';
import AudioTagPlaceholder from '../shared/MediaTag/AudioTagPlaceholder';

interface IReduxProps {
  can_load_more_next_up: boolean;
  currently_playing: ISoundtrack;
  next_up: ISoundtrack[];
  loading_more_next_up: boolean;
  queue: any;
  current_user: IUser;
}

function Queue() {
  const [activeEventKey, setActiveEventKey] = useState(null);
  const reduxProps = useSelector((state: IReduxProps) => state);

  const handleScroll = (e: Event) => {
    const target = e.target as Element;
    if (target.scrollHeight - target.clientHeight - target.scrollTop < 80) {
      if (
        reduxProps.can_load_more_next_up &&
        !reduxProps.loading_more_next_up
      ) {
        hv_player_api.loadNextUpOnNext();
      }
    }
  };

  const onSelectEventKey = (eventKey: any) => setActiveEventKey(eventKey);

  useEffect(() => {
    getMiddleColumn()?.addEventListener('scroll', handleScroll);
    return () => getMiddleColumn()?.removeEventListener('scroll', handleScroll);
  }, [reduxProps.can_load_more_next_up, reduxProps.loading_more_next_up]);

  useEffect(() => {
    hv_player_api.loadNextUpOnNext();
  }, [reduxProps.queue]);

  const renderHeader = () => (
    <div>
      <h1 className="mb-5">Play Queue</h1>
      <h3>Now Playing</h3>
      {reduxProps.currently_playing.type === 'SoundTrack' ? (
        <MediaFlatItem
          medium={reduxProps.currently_playing}
          source={{ type: 'queue', id: '' }}
          mediumSetter={hv_player_api.setCurrentlyPlayingTrack}
          eventKey={reduxProps.currently_playing.id.toString()}
          activeEventKey={reduxProps.currently_playing.id.toString()}
          sourceOwner={reduxProps.current_user}
          onRemoveFromQueue={hv_player_api.removeFromQueue}
          onAddToQueue={hv_player_api.addToQueue}
        />
      ) : reduxProps.currently_playing.status === 'fetching' ? (
        <AudioTagPlaceholder />
      ) : null}
      <h3 className="mt-5">Next Up</h3>
    </div>
  );

  const renderMedium = (medium: ISoundtrack, index: number) => (
    <MediaFlatItem
      key={medium.id.toString()}
      eventKey={medium.id.toString()}
      activeEventKey={activeEventKey}
      source={{ type: 'queue', id: '' }}
      sourceOwner={reduxProps.current_user}
      medium={medium}
      mediumSetter={hv_player_api.updateNextQueueTrackDetails}
      onRemoveFromQueue={hv_player_api.removeFromQueue}
      onAddToQueue={hv_player_api.addToQueue}
      onReportMedium={() => {}}
      onRemoveMedium={() => {}}
    />
  );

  console.log(reduxProps);

  return (
    <div className="m-4">
      <MediaFlatlist
        className="mx-4"
        media={reduxProps.next_up}
        loadingMoreMedia={reduxProps.loading_more_next_up}
        onSelectEventKey={onSelectEventKey}
        renderMedium={renderMedium}
        renderHeader={renderHeader}
      />
    </div>
  );
}

export default Queue;
